import { render, staticRenderFns } from "./AdminWhitelistAddForm.vue?vue&type=template&id=01b4af66&scoped=true"
import script from "./AdminWhitelistAddForm.vue?vue&type=script&lang=js"
export * from "./AdminWhitelistAddForm.vue?vue&type=script&lang=js"
import style0 from "./AdminWhitelistAddForm.vue?vue&type=style&index=0&id=01b4af66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b4af66",
  null
  
)

export default component.exports